import { render, staticRenderFns } from "./Certificado.vue?vue&type=template&id=8170601a&scoped=true"
import script from "./Certificado.vue?vue&type=script&lang=js"
export * from "./Certificado.vue?vue&type=script&lang=js"
import style0 from "./Certificado.vue?vue&type=style&index=0&id=8170601a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8170601a",
  null
  
)

export default component.exports